// extracted by mini-css-extract-plugin
export var copyIcon = "_se-2";
export var discountCard = "_se-0";
export var discountCode = "_se-3";
export var discountContent = "_se-1";
export var loadingCard = "_se-4";